import React, { useState, useEffect } from 'react';
//Material-UI
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
//Icons
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { GetTipoDocQuery } from '../queries';

const useStyles = makeStyles(theme => ({
   root: {
      height: '100%'
   },
   image: {
      height: 48,
      width: 48
   },
   actions: {
      justifyContent: 'flex-end'
   },
   avatar: {
      //backgroundColor: "",
   },
   header: {
      textAlign: 'center',
      spacing: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.h4,
      fontWeight: theme.typography.fontWeightMedium,
      //backgroundColor: theme.palette.background.paper,
      letterSpacing: '0.2px'
   },
   icons: {
      verticalAlign: 'middle', 
      marginRight: 6, 
      color: '#757575' 
   }
}));
/*
Funciones y variables auxiliares globales
*/
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};

const msgModalInicial = {
   open: false,
   mensaje: '',
   accionAceptar: false,
   aceptarLabel: 'Eliminar'
};
//Queries

const GeneralInformacion = props => {
   const classes = useStyles();
   const cliente = props.data || null;
   const openWaitModal = props.openWaitModal || null;
   const openMsgModal = props.openMsgModal || null;
   const [tipoDoc, setTipoDoc] = useState([])
   /**
    * Estados
    */
   /**
    * Funciones
    */
   const crearDenominacion = () => {
      let denominacion = '';
      if (cliente != undefined && cliente != null) {
         const tipoDocumento = cliente.tipoDoc;
         if (tipoDocumento === '6') {
            denominacion = cliente.razonSocial;
         } else {
            denominacion = `${cliente.nombre} ${cliente.apPaterno} ${cliente.apMaterno}`;
         }
      }
      return denominacion.trim();
   };
   const clienteDen = crearDenominacion();
   const [getTipoDoc, { loading: loadingTD, error: errorTD, data: dataTD }] = useLazyQuery(GetTipoDocQuery);

   useEffect(() => {
      openWaitModal(loadingTD)
   }, [loadingTD]);

   useEffect(() => {
      if (errorTD) {
         openMsgModal(JSON.stringify(errorTD))
      }
   }, [errorTD])

   useEffect(() => {
      if (dataTD) {
         setTipoDoc(dataTD.tipoDocumentoId);
      }
   }, [dataTD])

   useEffect(() => {
      if (cliente && cliente.tipoDoc) {
         getTipoDoc({
            variables: {
               codigo: cliente.tipoDoc
            }
         })
      }
   }, [cliente])

   return (
      <Card
      /*{...rest}
     className={clsx(classes.root, className)}*/
      >
         <CardHeader
            title={
               <Typography component="p" color="textPrimary" variant="h5">
                  Información general
               </Typography>
            }
            disableTypography={true}
            avatar={
               <Avatar className={classes.avatar}>
                  <BusinessCenterIcon />
               </Avatar>
            }
         />
         <Divider />
         <CardContent>
            <Typography variant="h6" color="textPrimary" gutterBottom>
               <PersonIcon fontSize='small' className={classes.icons}/>
               {clienteDen}
            </Typography>
            <Typography
               className={classes.locationText}
               color="textSecondary"
               variant="body1"
               component="div"
               style={{ marginBottom: 8 }}
            >
               <AssignmentIndIcon fontSize="small" className={classes.icons}/>
               {cliente.tipoDoc != null ?
                  (<>
                     <strong>{tipoDoc.descripcion}:</strong> {cliente.nroDoc || ''}
                  </>)
                  : ('Sin Nro. Documento Registrado')
               }
            </Typography>

            <Typography
               className={classes.locationText}
               color="textSecondary"
               variant="body1"
               component="div"
               style={{ marginBottom: 8 }}
            >
               <EmailIcon fontSize="small" className={classes.icons}/>
               <strong>Email:</strong> {cliente.email || 'Sin email registrado'}
            </Typography>

            <Typography
               className={classes.locationText}
               color="textSecondary"
               variant="body1"
               component="div"
            >
               <PhoneIcon fontSize="small" className={classes.icons}/>
               <strong>Teléfono:</strong> {cliente.telefono || 'Sin teléfono registrado'}
            </Typography>
         </CardContent>
         <Divider />
         <CardActions className={classes.actions}>
            {/*<Button
        startIcon={<EditIcon />}
      >
        Actualizar
      </Button>*/}
         </CardActions>
      </Card>
   );
};

export default GeneralInformacion;
